<div class="side-panel-container">
  <div class="panel-backdrop" id="panel-backdrop" [ngClass]="{'_opened': opened}"></div>

	<div class="side-panel" @slideLeftRight [ngClass]="{'_opened': opened}">
    <ng-content></ng-content>
  </div>
</div>